<ng-container *transloco="let t">

  <div class="row">
    <div class="col-md-6 col-sm-12">

<div class="card">
<div class="card-header with-border">
  <h3 class="card-title">{{ t('Tell me more about Safety Champions') }}</h3>
</div>
<div class="card-body">
<p>{{ t('Safety Champions show how each of your workers are using OK Alone.') }}</p>

<p>{{ t("At the end of each month we take all the worker's usage in OK Alone and review it to award a number of different") }} {{ t('badges') }} {{ t('and calculate a safety score.') }} </p>

</div>
</div><br/>


<div class="card">
<div class="card-header with-border">
  <h3 class="card-title">{{ t('Explaining the Report Card') }}</h3>
</div>
<div class="card-body">
    <img src="https://okalone.net/awards/demo/reportcard1.png" alt="Demo Report Card" class="img-fluid img-thumbnail pull-left m-1" style="max-width:250px;">

    <p>{{ t('A report card is generated each month for every worker who has a score above zero.') }}</p>

    <p><b>{{ t('Your Score:') }} </b> {{ t('This shows your score out of 100 for the month. This is created from your safe shifts, app feature usage, alert usage and location accuracy. It also shows how much you have increased or decreased compared to the previous month.') }}</p>

    <p><b>{{ t('Company Ranking:') }} </b> {{ t('Your position compared to others in your company who use OK Alone.') }}</p>
    <p><b>{{ t('Country Ranking:') }} </b> {{ t('Your current position amongst all the OK Alone users in your country.') }}</p>
    <p><b>{{ t('World Wide Ranking:') }} </b> {{ t('Your current position compared to every OK Alone user in the world.') }}</p>
    <p><b>{{ t('Badges:') }} </b> {{ t('These are the badges you have earned this month, what each badge means is explained below.') }}</p>

</div>
</div><br/>


<div class="card">
<div class="card-header with-border">
<h3 class="card-title">{{ t('Explaining Certificates') }}</h3>
</div>
<div class="card-body">
<img src="https://okalone.net/awards/demo/certificate1.png" alt="Demo Report Card" class="img-fluid pull-left m-1" style="max-width:250px;">

<p>{{ t('Certificates are issued every month to the top 10 workers in each company, country and the world.') }}</p>

<p>{{ t('The certificates can be shared online, by email or printed out for the office wall or your fridge at home!') }}</p>

</div>
</div><br/>


<div class="card">
<div class="card-header with-border">
<h3 class="card-title">{{ t('How do I get Certificates?') }}</h3>
</div>
<div class="card-body">
<p>
    {{ t('In order to receive a certificate you need to come in the top 10 workers in either your company, country or the world. This is dependant on your total score for the month.') }}
</p>

<p>
    {{ t('Each month we take into account a number of safety factors including missed check ins, location monitoring, shift starts and check in reminders and you are awarded a score out of 100. It is possible to get 100/100, however, any score over 75 is classed as very good.') }}
</p>
</div>
</div><br/>





</div>
<div class="col-md-6 col-sm-12">


<div class="card">
<div class="card-header with-border">
  <h3 class="card-title">{{ t('What are the Badges?') }}</h3>
</div>
<div class="card-body">
<p>{{ t('Each month your workers are awarded a number of badges based on how they used the system. These badges include features used, milestones reached and their rankings in relation to other workers in the company, country and world wide.') }}</p>

</div>
</div><br/>


<div class="card">
<div class="card-header with-border">
<h3 class="card-title">{{ t('How is the Score Calculated?') }}</h3>
</div>
<div class="card-body">
<p>{{ t('Each month a score out of 100 is awarded to each worker. This takes into account a number of safety factors including missed check ins, location monitoring, start shift and check in reminders. It is possible to get 100/100, however any score over 75 is classed as very good.') }}</p>
</div>
</div><br/>

<div class="card">
<div class="card-header with-border">
  <h3 class="card-title">{{ t('Why do some workers have no Scores or Badges?') }}</h3>
</div>
<div class="card-body">
  {{ t('To get a monthly score or badges the worker must be regularly using the OK Alone system. If they have used the system even just once they should start being awarded badges. The more they use the system and stay safe, the higher their score will be. To start getting the highest scores, a worker must be using the app at least 3 times a week for shifts of 2 hours or more.') }}
</div>
</div><br/>

<div class="card">
<div class="card-header with-border">
  <h3 class="card-title">{{ t('Tell me more about Company Rankings') }}</h3>
</div>
<div class="card-body">
<p>{{ t("Company rankings show how your company's safety scores compare to other companies in your country and in the world.") }}</p>

<p>{{ t('To calculate your company score, we take the average of your top 5 workers for this month. To be included in the ranking you must have at least 5 workers with a score of more than 0.') }}</p>

<p>{{ t('If you are not in Canada, The United Kingdom, The United States or Australia - we include you in the Rest of the World and your country ranking includes countries such as New Zealand, Norway, Malaysia and Germany.') }}</p>
    </div>
</div><br/>


<div class="card">
<div class="card-header with-border">
  <h3 class="card-title">{{ t('Why is my company not ranked?') }}</h3>
</div>
<div class="card-body">
{{ t('To get a company ranking, you must have at least 5 workers with a score of more than zero. We then take the average score of the top 5 workers for that month and compare them to other companies in the OK Alone family.') }}
</div>
</div><br/>



<div class="card">
<div class="card-header with-border">
  <h3 class="card-title">{{ t('Why are my workers not ranked?') }}</h3>
</div>
<div class="card-body">
{{ t('To get a ranking workers must have completed some shifts in the OK Alone system. Each month a score out of 100 is awarded to each worker. This takes into account a number of safety factors including missed check ins, location monitoring, start shift and check in reminders.') }}
</div>
</div><br/>

<p>{{ t('Got any questions or want to give us some feedback? Then please email us at') }} <a href="mailto:customer.support@ok-alone.com">customer.support&#64;ok-alone.com</a>


</div>
</div>

</ng-container>
